/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoPatologiaInfettivaCreateDTO
 */
export interface AssistitoPatologiaInfettivaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaCreateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaCreateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoPatologiaInfettivaCreateDTO interface.
 */
export function instanceOfAssistitoPatologiaInfettivaCreateDTO(value: object): value is AssistitoPatologiaInfettivaCreateDTO {
    return true;
}

export function AssistitoPatologiaInfettivaCreateDTOFromJSON(json: any): AssistitoPatologiaInfettivaCreateDTO {
    return AssistitoPatologiaInfettivaCreateDTOFromJSONTyped(json, false);
}

export function AssistitoPatologiaInfettivaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoPatologiaInfettivaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoPatologiaInfettivaCreateDTOToJSON(value?: AssistitoPatologiaInfettivaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

